import * as React from 'react';
import { Button } from 'antd';

import { DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { ObjectUtils } from 'src/core/utils/object';

interface IVersionDocumentListViewProps extends ComponentViewProps<DataSet<IFileSystemSummary>> {
    downloadDocument: (fileSystemId: IFileSystemSummary) => void;
    regenerateDocument: (fileSystem: IFileSystemSummary) => Promise<void>;
    setBusy: (isBusy: boolean) => void;
}

export class VersionDocumentListView extends React.Component<IVersionDocumentListViewProps, any> {
    constructor(props: IVersionDocumentListViewProps) {
        super(props);
    }

    render() {
        return (
            <DataTableView
                model={this.props.model}
                hideToolbar={ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hideSearch}
                columns={[
                    {
                        title: '',
                        key: 'id',
                        render: (value: any, record: IFileSystemSummary) => {
                            return (
                                <Button.Group>
                                    <Button
                                        icon="reload"
                                        size="small"
                                        onClick={() => this.props.regenerateDocument(record)}
                                    />
                                    <Button
                                        icon="download"
                                        size="small"
                                        onClick={() => this.props.downloadDocument(record)}
                                    />
                                </Button.Group>
                            );
                        },
                        width: '100px'
                    },
                    {
                        title: 'Version',
                        key: 'version',
                        dataIndex: 'version'
                    },
                    {
                        title: 'Size',
                        key: 'size',
                        dataIndex: 'size',
                        render: (value: number) => `${ObjectUtils.round(value / 1000)} Kb`
                    },
                    {
                        title: 'Shared with',
                        key: 'sharedWith'
                    },
                    {
                        title: 'Tags',
                        key: 'tags',
                        dataIndex: 'tags'
                    },
                    {
                        title: 'Owner',
                        key: 'ownerUserName',
                        dataIndex: 'ownerUserName'
                    }
                ]}
                setBusy={this.props.setBusy}
            />
        );
    }
}





// WEBPACK FOOTER //
// ./src/app/general/document-generation/parts/version-document-list.view.tsx